<template>
    <div class="dashboard">
        <div class="content-area">
            <base-header @sidemenu="$emit('responsiveSideBar')"></base-header>
            <div class="right-panel system-logs-page">
                <div class="wrap-content">
                    <div class="filter-section row-min-space">
                        <div class="row">
                            <div class="col-xs-12 col-md-12">
                                <h2>System Logs</h2>
                            </div>
                            <div class="col-xs-12 col-md-12">
                                <div class="row">
                                    <div class="col-xs-12 col-md-9">
                                        <div class="row">
                                            <div class="col-xs-12 col-md-5">
                                                <div class="row">
                                                    <div
                                                        class="col-xs-12 col-md-6"
                                                    >
                                                        <div
                                                            class="form-group custom-datepicker"
                                                        >
                                                            <date-picker
                                                                ref="start date"
                                                                v-model="
                                                                    query.from
                                                                "
                                                                v-validate="{
                                                                    required: true,
                                                                    date_format:
                                                                        'MM/dd/yyyy',
                                                                    before: maxStartDate,
                                                                }"
                                                                class="form-control"
                                                                name=" start date"
                                                                format="DD/MM/YYYY"
                                                                :class="{
                                                                    'is-invalid': errors.has(
                                                                        'start date'
                                                                    ),
                                                                }"
                                                                lang="en"
                                                            ></date-picker>

                                                            <i
                                                                :class="[
                                                                    {
                                                                        'disable-input': false,
                                                                    },
                                                                    'icon-calendar',
                                                                ]"
                                                            ></i>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="col-xs-12 col-md-6"
                                                    >
                                                        <div
                                                            class="form-group custom-datepicker"
                                                        >
                                                            <date-picker
                                                                ref="end date"
                                                                v-model="
                                                                    query.to
                                                                "
                                                                v-validate="{
                                                                    required: true,
                                                                    date_format:
                                                                        'MM/dd/yyyy',
                                                                }"
                                                                class="form-control"
                                                                name="end date"
                                                                format="DD/MM/YYYY"
                                                                :class="{
                                                                    'is-invalid': errors.has(
                                                                        'end date'
                                                                    ),
                                                                }"
                                                                lang="en"
                                                            ></date-picker>

                                                            <i
                                                                :class="[
                                                                    {
                                                                        'disable-input': false,
                                                                    },
                                                                    'icon-calendar',
                                                                ]"
                                                            ></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-md-7">
                                                <div class="row">
                                                    <div
                                                        class="col-xs-12 col-md-4"
                                                    >
                                                        <b-form-group>
                                                            <b-form-select
                                                                id="input-3"
                                                                v-model="
                                                                    query.module
                                                                "
                                                                class="form-control"
                                                                :options="
                                                                    systemLogModules
                                                                "
                                                                @change="
                                                                    setActionOptions
                                                                "
                                                            ></b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                    <div
                                                        class="col-xs-12 col-md-4"
                                                    >
                                                        <b-form-group>
                                                            <b-form-select
                                                                id="input-3"
                                                                v-model="
                                                                    query.action
                                                                "
                                                                :disabled="
                                                                    !query.module
                                                                "
                                                                class="form-control"
                                                            >
                                                                <option
                                                                    v-for="(action,
                                                                    index) in filterAction"
                                                                    :key="index"
                                                                    :title="
                                                                        action.text
                                                                    "
                                                                    :value="
                                                                        action.value
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            index >
                                                                                0
                                                                        "
                                                                        >{{
                                                                            action.text.substring(
                                                                                0,
                                                                                14
                                                                            ) +
                                                                                (action
                                                                                    .text
                                                                                    .length >
                                                                                14
                                                                                    ? '...'
                                                                                    : '')
                                                                        }}</span
                                                                    >
                                                                    <span
                                                                        v-else
                                                                        >{{
                                                                            action.text
                                                                        }}</span
                                                                    >
                                                                </option>
                                                            </b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                    <div
                                                        class="col-xs-12 col-md-4"
                                                    >
                                                        <b-form-group>
                                                            <b-form-select
                                                                id="input-3"
                                                                v-model="
                                                                    query.userId
                                                                "
                                                                class="form-control"
                                                            >
                                                                <option
                                                                    v-for="(user,
                                                                    index) in usersFilter"
                                                                    :key="index"
                                                                    :title="
                                                                        user.text
                                                                    "
                                                                    :value="
                                                                        user.value
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            index >
                                                                                0
                                                                        "
                                                                        >{{
                                                                            user.text.substring(
                                                                                0,
                                                                                12
                                                                            ) +
                                                                                (user
                                                                                    .text
                                                                                    .length >
                                                                                12
                                                                                    ? '...'
                                                                                    : '')
                                                                        }}</span
                                                                    >
                                                                    <span
                                                                        v-else
                                                                        >{{
                                                                            user.text
                                                                        }}</span
                                                                    >
                                                                </option>
                                                            </b-form-select>
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xs-12 col-md-3">
                                        <div class="row">
                                            <div class="col-xs-12 col-md-6">
                                                <button
                                                    class="btn btn-primary"
                                                    type="submit"
                                                    :class="
                                                        loading &&
                                                        showPageLoader
                                                            ? 'disabled'
                                                            : ''
                                                    "
                                                    @click="apply"
                                                >
                                                    <span class="btn-text"
                                                        >Apply</span
                                                    >
                                                    <span class="loader"></span>
                                                </button>
                                            </div>
                                            <div
                                                class="col-xs-12 col-md-6 export-btn-section"
                                            >
                                                <b-button
                                                    type="button"
                                                    :class="[
                                                        data.length > 0
                                                            ? 'secondary-add-btn'
                                                            : 'secondary-add-btn button-disabled',
                                                    ]"
                                                    variant="secondary"
                                                    @click="exportRecords"
                                                >
                                                    <span class="btn-text"
                                                        >EXPORT</span
                                                    >
                                                </b-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 col-md-12">
                            <!-- system logs total actions -->
                            <div
                                v-show="data.length > 0"
                                class="chart-container"
                            >
                                <div
                                    id="logs-total-actions"
                                    class="amcharts-div logs-total-actions"
                                ></div>
                            </div>
                            <!-- When data is loading -->
                            <base-table-spinner
                                v-if="!data.length && showPageLoader"
                            ></base-table-spinner>
                            <!-- When record not found -->
                            <base-no-record-found
                                v-if="!data.length && !showPageLoader"
                            ></base-no-record-found>
                        </div>
                    </div>

                    <div v-show="data.length > 0" class="row">
                        <div class="col-xs-12 col-md-12">
                            <div
                                :class="[
                                    'table-section',
                                    'table-min-width',
                                    'system-logs-table',
                                    {
                                        'overflow-hidden':
                                            !data.length && !showPageLoader,
                                    },
                                ]"
                            >
                                <b-table
                                    :fields="systemLogFields"
                                    :items="data"
                                    no-local-sorting
                                    @sort-changed="sortingChanged"
                                >
                                    <template
                                        slot="createdAt"
                                        slot-scope="data"
                                    >
                                        <div class="action-flex">
                                            <span>
                                                {{
                                                    $moment(
                                                        data.item.createdAt
                                                    ).format(
                                                        'ddd, MMM D, YYYY hh:mm:ss'
                                                    )
                                                }}
                                            </span>
                                        </div>
                                    </template>
                                </b-table>
                            </div>

                            <base-records
                                ref="baseRecords"
                                path="system-logs/"
                                :query="query"
                                :reset="reset"
                                :show-pagination="true"
                            ></base-records>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <export-process-popup
            :id="id"
            title="Export System Logs"
            :url="cancelUrl"
        ></export-process-popup>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import exportProcessPopup from '@/components/popups/ExportProcessPopup.vue'
import DatePicker from 'vue2-datepicker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import resource from '@/api/resource'
import request from '@/utils/request'

const statsApi = new resource('system-logs/stats')
const usersApi = new resource('system-users/')

require('amcharts3')
require('amcharts3/amcharts/serial')
require('amcharts3/amcharts/pie')

export default {
    components: {
        exportProcessPopup,
        DatePicker,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            query: {
                startAt: 1,
                perPage: 10,
                userId: null,
                module: null,
                action: null,
                from: this.$moment()
                    .add(-30, 'days')
                    .format('MM/DD/YYYY'),

                to: this.$moment().format('MM/DD/YYYY'),
            },
            reset: new Date().getTime(),
            fields: [],
            items: [],
            disabledDates: this.$moment().format('MM/DD/YYYY'),
            filterAction: [{ text: 'Filter by action', value: null }],
            id: null,
            cancelUrl: 'system-logs/cancel-export',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'dataSegmentId',
            'data',
            'showPageLoader',
            'loading',
            'systemLogsData',
            'systemLogFields',
            'systemLogModules',
            'systemLogActions',
            'usersList',
            'totalRecords',
            'displaySettings',
        ]),

        /*users list for filter*/
        usersFilter() {
            let options = [{ text: 'Filter by user', value: null }]
            this.usersList.forEach(function(ele) {
                options.push({ text: ele.username, value: ele._id })
            })
            return options
        },
        maxStartDate() {
            return this.$moment(this.query.to)
                .add(1, 'day')
                .format('MM/DD/YYYY')
        },
    }, // End of Component > computed
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.showStats()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.showStats()
        this.getUsersList()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getUsersList() {
            if (!this.usersList.length) {
                let { data } = await usersApi.list({ perPage: 1000 })
                this.$store.commit('setUsersList', data.data)
            }
        }, //End of getUsersList() method
        getKeyword(val) {
            this.query.keyword = val
        }, // End of getKeyword() method

        async apply() {
            const result = await this.$validator.validateAll()
            if (result) {
                this.$store.commit('setLoading', true)
                this.showStats()
                this.reset = new Date().getTime()
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of apply() method

        selectedRecord(record) {
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy

            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? -1 : 1

            this.apply()
        }, // End of sortingChanged() method

        async showStats() {
            if (this.dataSegmentId) {
                var counter = false
                let { data } = await statsApi.list({
                    from: this.query.from,
                    to: this.query.to,
                    userId: this.query.userId,
                    module: this.query.module,
                    action: this.query.action,
                    dataSegmentId: this.dataSegmentId,
                })
                let logsTotalActions = JSON.parse(
                    JSON.stringify(this.systemLogsData.totalActions)
                )
                logsTotalActions.dataProvider = data.data.length
                    ? data.data
                    : []
                logsTotalActions.listeners = [
                    {
                        event: 'zoomed',
                        method: function(e) {
                            if (counter) {
                                this.query.from = this.$moment(
                                    e.startDate
                                ).format('MM/DD/YYYY')
                                this.query.to = this.$moment(e.endDate).format(
                                    'MM/DD/YYYY'
                                )
                                this.reset = new Date().getTime()
                                this.showStats()
                            }
                            counter = true
                        }.bind(this),
                    },
                    {
                        event: 'clickGraphItem',
                        method: function(e) {
                            this.query.from = this.$moment(
                                e.item.dataContext.date
                            ).format('MM/DD/YYYY')
                            this.query.to = this.$moment(
                                e.item.dataContext.date
                            ).format('MM/DD/YYYY')
                            this.reset = new Date().getTime()
                            this.showStats()
                        }.bind(this),
                    },
                ]
                if (this.displaySettings) {
                    logsTotalActions.colors = [
                        this.displaySettings.colors.primary,
                    ]
                    logsTotalActions.chartCursor.cursorColor = this.displaySettings.colors.secondary
                }
                window.AmCharts.makeChart(
                    'logs-total-actions',
                    logsTotalActions
                )
            }
        },

        setActionOptions(value) {
            if (value) {
                this.query.action = null
                this.filterAction = this.systemLogActions[value]
                this.query.action = this.filterAction[0].value
            } else {
                this.query.action = null
            }
        },

        async exportRecords() {
            try {
                let { data } = await request.post('system-logs/export', null, {
                    params: {
                        from: this.query.from,
                        to: this.query.to,
                        dataSegmentId: this.dataSegmentId,
                        userId: this.query.userId,
                        module: this.query.module,
                        action: this.query.action,
                    },
                })

                this.id = data.data.id
                this.$bvModal.show('export-process-popup')
                this.$toasted.show(data.message, {
                    type: 'success',
                })
            } catch (error) {
                // console.log(error, 'error')
            }
        },
    },
} // End of export default
</script>
